import configuration from "@/utils/Config";
import { restPostHandler } from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { TokenCreationBody } from "@state/editorToken/dto/request/TokenCreationBody";
import { GetCallbackUrlBody } from "@state/editorToken/dto/request/GetCallbackUrlBody";

const baseUrl = configuration.backendBaseUrl;
const generateEditorUserTokenUrl =
  baseUrl + "/ws/fo/user/generateEditorUserToken";
const generateEditorUserAllOfficesTokenUrl =
  baseUrl + "/ws/fo/user/generateEditorUserAllOfficesToken";
const getCallbackURLUrl = baseUrl + "/ws/fo/user/getCallbackURL";
const linkOfficeToTokenUrl = baseUrl + "/ws/fo/user/linkOfficeToToken";
const linkOfficeUserToTokenUrl = baseUrl + "/ws/fo/user/linkOfficeUserToToken";

export const requestPostGenerateEditorUserToken = createEffect({
  handler: restPostHandler<TokenCreationBody, void>(generateEditorUserTokenUrl),
});

export const requestPostGenerateEditorUserAllOfficesToken = createEffect({
  handler: restPostHandler<TokenCreationBody, void>(
    generateEditorUserAllOfficesTokenUrl,
  ),
});

export const requestPostGetCallbackUrl = createEffect({
  handler: restPostHandler<GetCallbackUrlBody, string>(getCallbackURLUrl),
});

export const requestPostLinkOfficeToToken = createEffect({
  handler: restPostHandler<TokenCreationBody, void>(linkOfficeToTokenUrl),
});

export const requestPostLinkOfficeUserToToken = createEffect({
  handler: restPostHandler<TokenCreationBody, void>(linkOfficeUserToTokenUrl),
});
